import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  ViewChild,
  ViewEncapsulation
}                                  from '@angular/core';
import {ApDynformsComponent}       from '../../ap-dynforms/ap-dynforms.component';
import {ApDynformsConfigFieldset}  from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {Subscription}              from 'rxjs';
import {ApDynformsConfigLabelIcon} from '../../ap-dynforms/config/ap-dynforms-config-label-icon';
import {ContactInformationStore}   from '../../stores/common/contactinformation.store';
import {MapViewStore}              from '../../stores/layout/mapview.store';
import {MapStore}                  from '../../stores/map/map.store';
import {ApWindowHelperService}     from '../../ap-core/services/ap-window-helper.service';
import IContactInformation = Data.Common.IContactInformation;

@Component({
  selector: 'ap-info-contact',
  template: `
    <ap-dynforms [fieldsets]="formConfig" [caption]="'Tip_ContactText'">
    </ap-dynforms>
    <div *ngIf="(loading$ | async)">
      <div
        style="position: fixed; width: 20%; z-index: 2; top: 50%; left: 50%; margin-top: -10%; margin-left: -10%; padding: 10px; text-align: center;">
        <kendo-loader [type]="'converging-spinner'" [size]="'large'"  [themeColor]="'secondary'"></kendo-loader>
        <p>{{'Global_Loading' | translate}}...</p>
      </div>
    </div>
    <ap-info-version></ap-info-version>
  `,
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class InfoContactComponent implements AfterContentInit, OnDestroy {
  @ViewChild(ApDynformsComponent, {static: true}) dynForm: ApDynformsComponent;
  public formConfig: ApDynformsConfigFieldset[];
  private infos: IContactInformation[];
  public loading$;
  private _subscriptions: Array<Subscription> = [];

  constructor(private mapViewStore: MapViewStore,
              private mapStore: MapStore,
              private contactInformationStore: ContactInformationStore,
              private windowHelper: ApWindowHelperService) {
    this.windowHelper.openSite('https://www.agricon.de/ansprechpartner');
    this.mapViewStore.showMapView();
  }

  ngAfterContentInit(): void {
    this.loading$ = this.contactInformationStore.Listen(s => s.loading);
    this.contactInformationStore.loadContactInformation();
    this.getDataFromStore();
  }

  getDataFromStore(): void {
    this._subscriptions.push(this.contactInformationStore.Listen(s => s.data).subscribe(async infos => {
      if (!infos) {
        return;
      }
      this.infos = infos;
      // await this.mapStore.Layers.ContactLayer.replaceSource(this.infos);
      // this.mapStore.Layers.ContactLayer.ZoomIn(2500);
      this.formBuilder();
    }));
  }

  ngOnDestroy(): void {
    this.mapStore.Layers.RemoveContactLayer();
    this._subscriptions.forEach(d => {
      d.unsubscribe();
    });
  }

  formBuilder(): void {
    const configData = [];
    for (const info of this.infos) {
      configData.push(new ApDynformsConfigLabelIcon({
        key: info.Language_Key,
        src: info.Img_Src_Path,
        label1: 'Docu_Ini__PhoneShort',
        text1: info.Tel || '',
        label2: 'Global__Email',
        text2: info.Email || ''
      }));
    }
    this.formConfig = [];
    this.formConfig = [
      new ApDynformsConfigFieldset({
        key: 'contact_fieldset',
        columns: 1,
        legend: '',
        label: '',
        config: configData
      })
    ];
  }
}
